/**
 * Fleet Scatter page (day/explore SCATTER).
 *
 * Thin wrapper: renders the shared project-wide ScatterHistory page in `fleetDay` mode — the date
 * range is pinned to the day being viewed (no date-range picker) and the charts come from the
 * `fleet_scatter` objects the fleet Scatter builder writes (`/scatter-builder?fleet=true`), which the
 * sidebar already lists as the SCATTER submenu in day mode.
 *
 * See reports/gp50/project/all/explore/ScatterHistory.tsx for the `fleetDay` behavior.
 */
import ScatterHistoryPage from "../../project/all/explore/ScatterHistory";

export default function FleetScatterPage(props: Record<string, unknown>) {
  return <ScatterHistoryPage {...props} fleetDay={true} />;
}
